import { render } from "./SkillPage.vue?vue&type=template&id=739d5c94"
import script from "./SkillPage.vue?vue&type=script&lang=js"
export * from "./SkillPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__